module.exports = __webpack_public_path__ + "img/heibaimozhenxingdaiWu.min.64b66cce.png";